import { render, staticRenderFns } from "./paneles.vue?vue&type=template&id=4053400c&scoped=true&"
import script from "./paneles.vue?vue&type=script&lang=js&"
export * from "./paneles.vue?vue&type=script&lang=js&"
import style0 from "./paneles.vue?vue&type=style&index=0&id=4053400c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4053400c",
  null
  
)

export default component.exports